import {
  Checkbox,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getTheme } from "../../theme";
import { CostsConfig } from "../../types/costsConfig";
import OverallCosts from "../Reuseables/DashboardComponents/Savings/OverallCosts";
import { CostsCalculations } from "../../types/costsCalculations";
import { calculateCostsPerYear } from "../../helpers/utils";
import ROIPerOrganization from "../Reuseables/DashboardComponents/Savings/ROIPerOrganization";
import InputCosts from "../Reuseables/DashboardComponents/Savings/InputCosts";
import { useOrganizationContext } from "../ContextProviders/OrganizationContext";
import { getOrganizationInputCosts } from "../../api/getOverviewData";

export default function Savings() {
  const { organizations, activeWorkspace, setActiveWorkspace } =
    useOrganizationContext();
  const [costsConfigs, setCostConfigs] = useState<CostsConfig[]>([]);
  const [selectedCostConfig, setSelectedCostConfig] = useState<CostsConfig>();
  const [calculations, setCalculations] = useState<CostsCalculations>();

  useEffect(() => {
    const fetchCostsConfigs = async () => {
      if (organizations.length === 0) return;
      let costsConfigsTmp: CostsConfig[] = [];

      for (const org of organizations) {
        const fetchedConfig: CostsConfig = await getOrganizationInputCosts(
          org.id
        );
        if (fetchedConfig) {
          costsConfigsTmp.push(fetchedConfig);
        }
      }
      setCostConfigs(costsConfigsTmp);
      setSelectedCostConfig(costsConfigsTmp[0]);
    };

    fetchCostsConfigs();
  }, [organizations]);

  useEffect(() => {
    if (selectedCostConfig) {
      setSelectedCostConfig(
        costsConfigs.find(
          (config) =>
            config.organizationId === selectedCostConfig.organizationId
        ) || costsConfigs[0]
      );
      setCalculations(
        calculateCostsPerYear({ costsConfig: selectedCostConfig })
      );
    }
  }, [selectedCostConfig, costsConfigs]);

  const theme = useTheme();

  const handleWorkspaceChange = (event: any) => {
    const {
      target: { value },
    } = event;
    const matchingConfig = costsConfigs.find(
      (config) => config.organizationId === value
    );
    if (matchingConfig) {
      setSelectedCostConfig(matchingConfig);
    }
  };

  return (
    <>
      <Grid
        container
        sx={{ flexDirection: "column" }}
        spacing={3}
        justifyContent={"space-between"}
        paddingLeft={{ xs: 2, sm: 2, md: 4, lg: 6, xl: 6 }}
        paddingRight={{ xs: 2, sm: 2, md: 4, lg: 6, xl: 6 }}
      >
        <Grid item>
          <Grid
            container
            alignItems={"end"}
            spacing={3}
            flexDirection={{
              xs: "column",
              sm: "column",
              md: "row",
              lg: "row",
              xl: "row",
            }}
          >
            <Grid item xs>
              <Grid container spacing={2} flexDirection={"column"}>
                <Grid item>
                  <Typography
                    variant="h4"
                    sx={{ color: theme.palette.text.primary }}
                  >
                    Savings Dashboard
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="h6" sx={{ fontWeight: "normal" }}>
                    ROI Analysis of projects and industries measured.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid
                container
                spacing={2}
                flexDirection={{
                  xs: "column",
                  sm: "column",
                  md: "row",
                  lg: "row",
                  xl: "row",
                }}
              >
                <Grid item>
                  {activeWorkspace && selectedCostConfig && (
                    <FormControl sx={{ width: "200px" }}>
                      <InputLabel>Organization</InputLabel>
                      <Select
                        value={selectedCostConfig.organizationId}
                        onChange={handleWorkspaceChange}
                        input={<OutlinedInput label="Organization" />}
                      >
                        {costsConfigs.map((config: CostsConfig) => (
                          <MenuItem
                            key={config.organizationId}
                            value={config.organizationId}
                          >
                            {config.organizationName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs>
          <Divider sx={{ borderBottomWidth: 1 }} />
        </Grid>

        <Grid item xs></Grid>
        <Grid item xs>
          <Grid
            container
            spacing={4}
            flexDirection="column"
          >
            <Grid item xs>
              <Grid
                container
                spacing={3}
                flexDirection={{
                  xs: "column",
                  sm: "column",
                  md: "row",
                  lg: "row",
                  xl: "row",
                }}
              >
                <Grid item xs> 

                    <InputCosts
                      height={500}
                      selectedCostsConfig={selectedCostConfig}
                      costsConfigList={costsConfigs}
                      costsConfigListSetter={setCostConfigs}
                    />
                </Grid>
                {/* <Grid item md={6} lg={6} xl={6}>
                    <ROIPerOrganization
                      costsConfigs={costsConfigs}
                      selectedConfig={selectedCostConfig}
                      height={500}
                    />
                </Grid> */}
              </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <OverallCosts
                  costsConfig={selectedCostConfig}
                  costsCalculations={calculations}
                  height={551}
                />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
